module.exports = __webpack_public_path__ + "img/score_chart.9f2fa4f0.png";